import {axios} from "react-netjoy";

const RequestFailureInterceptor: axios.AxiosInterceptorRequestErrorInputFunctionType<{}> = (error, serviceClient) => {
    console.log('RequestFailureInterceptor')
    console.log(JSON.stringify(error))
    throw error
}

export default RequestFailureInterceptor;
